import { Button } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";

type Props = {
  itemValues: { [key: string]: any };
  value: boolean | undefined;
  onChange: (newVal: boolean) => void;
  download: (id: string) => Promise<Blob>;
  readOnly?: boolean;
};

export const ExistingDocument: React.FC<Props> = ({
  itemValues,
  value,
  onChange,
  download,
  readOnly,
}) => {
  return (
    <>
      {itemValues.fileName && (
        <div>
          <DownloadLink
            fileName={itemValues.fileName}
            getBlob={() => download(itemValues.id)}
          >
            {({ fileName, handleClick, icon }) => (
              <Button
                color="primary"
                onClick={handleClick}
                style={{
                  textDecoration: value ? "line-through" : "",
                }}
                title="Click to download"
              >
                {fileName}
                &nbsp;
                {icon}
              </Button>
            )}
          </DownloadLink>
          {!readOnly ? (
            <Button
              onClick={() => onChange(!value)}
              color="secondary"
              title="Click to delete this document"
            >
              <Delete />
            </Button>
          ) : null}
        </div>
      )}
    </>
  );
};
